export const getNextPosition = (things) => things.length === 0 ? 1 : Math.max(...things.map(t => t.position)) + 1;
//# sourceMappingURL=getNextPosition.js.map